import flatpickr from 'flatpickr'
import { DateTime } from 'luxon';

// The preset the page loads with. ReportsController#default_start_at must match it.
const DEFAULT_PERIOD = 'Last 30 days';
import Chartkick from 'chartkick'
import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels';

window.Chartkick = Chartkick;
Chartkick.addAdapter(Chart);

const totalizer = {
  id: 'totalizer',

  beforeUpdate: chart => {
    let totals = {}
    let utmost = 0

    chart.data.datasets.forEach((dataset, datasetIndex) => {
      if (chart.isDatasetVisible(datasetIndex)) {
        utmost = datasetIndex
        dataset.data.forEach((value, index) => {
          totals[index] = (totals[index] || 0) + value
        })
      }
    })

    chart.$totalizer = {
      totals: totals,
      utmost: utmost
    }
  }
}
Chart.plugins.register(totalizer);
// Beyond this many columns the value labels collide into a jumble (e.g. an
// all-time monthly chart); tooltips still show the values on hover.
const DATALABELS_MAX_COLUMNS = 40;

Chart.helpers.merge(Chart.defaults.global.plugins.datalabels, {
  formatter: (value, ctx) => {

    var stacked = ctx.chart.config.options.scales.yAxes[0].stacked;

    if(stacked) {
      const total = ctx.chart.$totalizer.totals[ctx.dataIndex]
      return total.toString();
    }

    return ctx.dataset.data[ctx.dataIndex];
  },
  align: 'end',
  anchor: 'end',
  display: function(ctx) {
    if (ctx.chart.data.labels.length > DATALABELS_MAX_COLUMNS) {
      return false;
    }

    var stacked = ctx.chart.config.options.scales.yAxes[0].stacked;

    if(stacked) {
      return ctx.datasetIndex === ctx.chart.$totalizer.utmost && ctx.chart.$totalizer.totals[ctx.dataIndex] > 0
    }

    return ctx.dataset.data[ctx.dataIndex] > 0;
  }
});

var periodPickerDocumentClickHandler = null;
var summaryDefaults = null;

// The filter handler accumulates params onto data-summary-url and overwrites the
// tile text, so the server-rendered state has to be kept to restore it before caching.
function captureSummaryDefaults() {
  var summaryEl = document.querySelector('[data-summary-url]');
  if (!summaryEl) { summaryDefaults = null; return; }

  var values = {};
  summaryEl.querySelectorAll('[data-summary-value]').forEach(function(el) {
    values[el.getAttribute('data-summary-value')] = el.textContent;
  });
  summaryDefaults = { url: summaryEl.getAttribute('data-summary-url'), values: values };
}

function restoreSummaryDefaults() {
  var summaryEl = document.querySelector('[data-summary-url]');
  if (!summaryEl || !summaryDefaults) { return; }

  summaryEl.setAttribute('data-summary-url', summaryDefaults.url);
  summaryEl.querySelectorAll('[data-summary-value]').forEach(function(el) {
    var key = el.getAttribute('data-summary-value');
    if (key in summaryDefaults.values) { el.textContent = summaryDefaults.values[key]; }
  });
}

$(document).on("turbo:before-cache", function() {
  restoreSummaryDefaults();

  $('.social-profiles__list').select2('destroy');

  var picker = document.querySelector('.period-picker');
  if (!picker) { return; }

  var pickerInput = picker.querySelector('.period-picker__input');
  if (pickerInput && pickerInput._flatpickr) { pickerInput._flatpickr.destroy(); }

  // Reset to server-rendered state so a Turbo restoration visit doesn't
  // duplicate presets, show a stale label, or restore an open panel.
  picker.querySelector('.period-picker__presets').innerHTML = '';
  picker.querySelector('.period-picker__panel').style.display = 'none';
  picker.querySelector('.period-picker__trigger').setAttribute('aria-expanded', 'false');
  picker.querySelector('.period-picker__label').textContent = DEFAULT_PERIOD;

  if (periodPickerDocumentClickHandler) {
    document.removeEventListener('click', periodPickerDocumentClickHandler);
    periodPickerDocumentClickHandler = null;
  }
});

$(document).on('turbo:load', function() {
  captureSummaryDefaults();

  $('.social-profiles__list').select2({
    theme: "bootstrap",
    sorter: function(data) {
      return data.sort(function (a, b) {
          if(a.id == '-1') {
            return -1;
          }
          if(b.id == '-1') {
            return 1;
          }

          a = a.text.toLowerCase();
          b = b.text.toLowerCase();
          if (a > b) {
            return 1;
          } else if (a < b) {
            return -1;
          }
          return 0;
      });
    },
    templateSelection: function(data) {
      if($(data.element).data('profile-picture') == undefined) {
        return data.text;
      }
      var img = $('<img>').attr('src',$(data.element).data('profile-picture')).addClass('social-profiles__img');
      return $('<div style="display:inline">').append(img).append(' ' + data.text);
    },
    templateResult: function(data) {
      if($(data.element).data('profile-picture') == undefined) {
        return $('<div style="margin-left: 30px">').append(data.text);
      }
      var img = $('<img>').attr('src',$(data.element).data('profile-picture')).addClass('social-profiles__img');
      return $('<div style="display:inline">').append(img).append(' ' + data.text);
    }
  }); 
  
  $('.social-profiles__list').on('change.select2', function (e) {
    var select2data = $('.social-profiles__list').select2('data')
    e.currentTarget.dispatchEvent(new CustomEvent('report_filter:changed', { bubbles: true, detail: { social_profile: select2data[0] } }));
  });

  var dt = DateTime.local();

  var picker = document.querySelector('.period-picker');
  if (picker) {
    var panel = picker.querySelector('.period-picker__panel');
    var trigger = picker.querySelector('.period-picker__trigger');
    var label = picker.querySelector('.period-picker__label');
    var minDate = picker.getAttribute('data-min-date');

    var presets = [
      { label: 'Month to date', start: dt.startOf('month'), end: dt.endOf('day') },
      { label: 'Last month', start: dt.minus({months: 1}).startOf('month'), end: dt.minus({months: 1}).endOf('month') },
      { label: 'Last 30 days', start: dt.minus({days: 31}).startOf('day'), end: dt.minus({days: 1}).endOf('day') },
      { label: 'Last 90 days', start: dt.minus({days: 91}).startOf('day'), end: dt.minus({days: 1}).endOf('day') },
      { label: 'Year to date', start: dt.startOf('year'), end: dt.endOf('day') },
      { label: 'Last 12 months', start: dt.minus({months: 12}).startOf('day'), end: dt.endOf('day') },
      { label: 'All time', start: DateTime.fromISO(minDate).startOf('day'), end: dt.endOf('day') }
    ];

    var defaultPreset = presets.filter(function(preset) { return preset.label === DEFAULT_PERIOD; })[0];
    var appliedDates = [defaultPreset.start.toJSDate(), defaultPreset.end.toJSDate()];
    var fp = null;

    // flatpickr measures widths at build time: init must happen while the panel
    // is visible, and 4.5.1 needs its multiMonth container width corrected.
    function ensureCalendar() {
      if (fp) { return; }
      fp = flatpickr(picker.querySelector('.period-picker__input'), {
        inline: true,
        mode: 'range',
        showMonths: 2,
        minDate: minDate,
        maxDate: dt.endOf('day').toJSDate(),
        defaultDate: appliedDates
      });
      var cal = panel.querySelector('.flatpickr-calendar');
      var dayW = cal.querySelector('.dayContainer').offsetWidth;
      cal.style.width = ((dayW + 1) * 2) + 'px';
    }

    function openPanel() {
      panel.style.display = 'flex';
      trigger.setAttribute('aria-expanded', 'true');
      ensureCalendar();
      var first = panel.querySelector('.period-picker__preset');
      if (first) { first.focus(); }
    }

    function closePanel(returnFocus) {
      panel.style.display = 'none';
      trigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) { trigger.focus(); }
    }

    function isOpen() { return panel.style.display !== 'none'; }

    function applyDates(dates, labelText) {
      appliedDates = dates;
      label.textContent = labelText;
      closePanel(true);
      picker.dispatchEvent(new CustomEvent('report_filter:changed', { bubbles: true, detail: { dates: dates } }));
    }

    function rangeLabel(dates) {
      var s = DateTime.fromJSDate(dates[0]);
      var e = DateTime.fromJSDate(dates[1]);
      return s.toFormat('MMM d, yyyy') + ' – ' + e.toFormat('MMM d, yyyy');
    }

    var presetList = picker.querySelector('.period-picker__presets');
    presets.forEach(function(preset) {
      var li = document.createElement('li');
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'period-picker__preset';
      button.textContent = preset.label;
      button.addEventListener('click', function() {
        var dates = [preset.start.toJSDate(), preset.end.toJSDate()];
        fp.setDate(dates, false);
        applyDates(dates, preset.label);
      });
      li.appendChild(button);
      presetList.appendChild(li);
    });

    trigger.addEventListener('click', function() {
      if (isOpen()) { closePanel(true); } else { openPanel(); }
    });

    picker.querySelector('.period-picker__apply').addEventListener('click', function() {
      var dates = fp.selectedDates;
      if (dates.length < 2) { return; }
      var start = DateTime.fromJSDate(dates[0]).startOf('day').toJSDate();
      var end = DateTime.fromJSDate(dates[1]).endOf('day').toJSDate();
      applyDates([start, end], rangeLabel(dates));
    });

    picker.querySelector('.period-picker__cancel').addEventListener('click', function() {
      fp.setDate(appliedDates, false);
      closePanel(true);
    });

    picker.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen()) {
        e.stopPropagation();
        fp.setDate(appliedDates, false);
        closePanel(true);
      }
    });

    // Focus trap: Tab wraps within the open panel (calendar has no tab stops)
    panel.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab') { return; }
      var focusables = panel.querySelectorAll('button, [href], input:not([tabindex="-1"]), select, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) { return; }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    periodPickerDocumentClickHandler = function(e) {
      if (isOpen() && !e.target.closest('.period-picker')) {
        fp.setDate(appliedDates, false);
        closePanel(false);
      }
    };
    document.addEventListener('click', periodPickerDocumentClickHandler);
  }

});

$(document).on('report_filter:changed', function (e) {
  var zone = $('#current-user-time-zone').data('time-zone');
  var start_at = null;
  var end_at = null;
  var social_profile = null;

  if (e.detail.dates != null) {
    start_at = DateTime.fromISO(e.detail.dates[0].toISOString()).setZone(zone, { keepLocalTime: true }).toISO();
    end_at = DateTime.fromISO(e.detail.dates[1].toISOString()).endOf('day').setZone(zone, { keepLocalTime: true }).toISO();
  }

  if (e.detail.social_profile != null) {
    social_profile = e.detail.social_profile.id;
  }

  // The server picks the bucket size for the (possibly clamped) range and
  // reports it in summary_data; the axes have to match it or Chart.js draws
  // sliver-thin columns on ticks of the wrong granularity.
  var updateCharts = function(period) {
    Chartkick.eachChart( function(chart) {
      if (period != null) {
        chart.options.library.scales.xAxes[0].time = { unit: period };
      }

      var url = chart.dataSource.split('?')[0];
      var query = chart.dataSource.split('?')[1];
      var params = new URLSearchParams(query)

      if (start_at != null) {
        params.set('start_at', start_at)
      }

      if (end_at != null) {
        params.set('end_at', end_at)
      }

      if (social_profile != null) {
        params.set('social_profile', social_profile);
      }

      chart.updateData(url + '?' + params.toString());
    });
  };

  $('.download-link').each(function(index, el) {
    var url = el.href.split('?')[0];
    var query = el.href.split('?')[1];
    var params = new URLSearchParams(query)
     
    if (start_at != null) {
      params.set('start_at', start_at)
    }

    if (end_at != null) {
      params.set('end_at', end_at)
    }

    if (social_profile != null) {
      params.set('social_profile', social_profile);
    }
    
    el.href = url + '?' + params.toString();
  });

  var summaryEl = document.querySelector('[data-summary-url]');
  if (summaryEl) {
    var summaryUrl = summaryEl.getAttribute('data-summary-url').split('?')[0];
    var summaryQuery = summaryEl.getAttribute('data-summary-url').split('?')[1];
    var summaryParams = new URLSearchParams(summaryQuery)

    if (start_at != null) {
      summaryParams.set('start_at', start_at)
    }

    if (end_at != null) {
      summaryParams.set('end_at', end_at)
    }

    if (social_profile != null) {
      summaryParams.set('social_profile', social_profile);
    }

    var summaryFetchUrl = summaryUrl + '?' + summaryParams.toString();
    summaryEl.setAttribute('data-summary-url', summaryFetchUrl);

    fetch(summaryFetchUrl, {
      headers: { 'Accept': 'application/json' }
    })
      .then(function(response) { return response.json(); })
      .then(function(summary) {
        Object.keys(summary).forEach(function(key) {
          var el = document.querySelector('[data-summary-value="' + key + '"]');
          if (el) { el.textContent = summary[key]; }
        });
        updateCharts(summary.period);
      })
      .catch(function(error) {
        console.error('Summary tile refresh failed', error);
        updateCharts(null);
      });
  } else {
    updateCharts(null);
  }

});
